module.exports = __webpack_public_path__ + "img/s4.6748c12b.svg";